import React, { useContext } from "react";
import { ResetPasswordContext } from "../ResetPasswordView";
import LoginLogo from "../../../assets/images/clsm-logo.svg";

import "./resetPage.css";
import ThemeInput from "../../../components/ThemeInput/ThemeInput";
import ThemeButton from "../../../components/ThemeButton/ThemeButton";
import EyeOpen from "../../../assets/images/icons/password-show.svg";
import EyeClose from "../../../assets/images/icons/password-hide.svg";
import Loader from "../../../components/Loader/Loader";
import PopupAlert from "../../../components/PopupAlertSuccess/PopupAlert";
import PopupAlertError from "../../../components/PopupAlertError/PopupAlertError";
import LinkExpired from "../../../assets/images/404img.png";

const ResetPasswordPage = () => {
  const {
    passwordType,
    toggleEyeIcon,
    confirmPasswordType,
    toggleEyeIconConfirm,
    pageContent,
    spinnerStatus,
    resetError,
    errorAlertMessage,
    errorAlertShow,
    setErrorAlertShow,
    submitnewPasswordapi,
    statusCode,
    password,
    handleConfirmPasswordChange,
    pageToForgotpassword,
    handlePasswordChange,
    passwordValidateMsg,
    confirmPassword,
    handleSucessClose,
    successMessage,
    successModal,
    validateResetToken,
    handleBlur,
  } = useContext(ResetPasswordContext);

  return (
    // main div starts

    <div className="resetPasswordPage">
      {spinnerStatus && <Loader />}
      {validateResetToken ? (
        <div className="resetPasswordPage loginPage">
       
          <div className="loginEnter">
            <div className="flexContentData">
              <h3>
                <img src={LoginLogo} alt="logo" />
              </h3>

              <p className="mb-2 formSubTitle">
                {pageContent.resetPasswordTitle}
              </p>
              <p className="mb-3 subTitleLogin">
                {pageContent.resetPasswordSubTitle}
              </p>
              <form onSubmit={submitnewPasswordapi}>
                {/* Email Input starts*/}
                <label className="input-label mt-4 mb-1">
                  {pageContent.newPasswordLabel}
                </label>
                <div className="icon-input">
                  <ThemeInput
                    placeholder={pageContent.newPasswordPlaceholder}
                    type={passwordType}
                    value={password}
                    onChange={handlePasswordChange}
                    onBlur={() => handleBlur("password")}
                  />
                  <span className="eye-icon" onClick={toggleEyeIcon}>
                    {passwordType === "password" ? (
                      <img src={EyeOpen} alt="Eye-open" />
                    ) : (
                      <img src={EyeClose} alt="Eye-close" />
                    )}
                  </span>
                </div>
                <p className="mb-0 error-msg">{resetError ? resetError : ""}</p>
                {/* Email Input ends*/}

                {/* password input starts */}
                <label className="input-label mt-3 mb-1">
                  {pageContent.confirmPasswordLabel}
                </label>
                <div className="icon-input">
                  <ThemeInput
                    placeholder={pageContent.confirmPasswordPlaceholder}
                    type={confirmPasswordType}
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    onBlur={() => handleBlur("confirmPassword")}
                  />
                  <span className="eye-icon" onClick={toggleEyeIconConfirm}>
                    {confirmPasswordType === "password" ? (
                      <img src={EyeOpen} alt="Eye-open" />
                    ) : (
                      <img src={EyeClose} alt="Eye-close" />
                    )}
                  </span>
                </div>
                <p className="mb-0 error-msg">
                  {passwordValidateMsg ? passwordValidateMsg : ""}
                </p>
                {/* password input ends */}

                {/* forgot password div starts */}
                {/* <div className="password-wrap">
              <div className="rememberme-text mt-3"></div>
              <div
                className="forgot-password-txt text-end mt-3"
                onClick={pageToForgotpassword}
              >
                {pageContent.forgotPassword}
              </div>
            </div> */}
                {/* forgot password div ends */}

                {/* submit button */}
                <ThemeButton
                  value={pageContent.submitText}
                  id="reSubmitbtns"
                  className="mt-4"
                  type="submit"
                />
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="expiryLinkPage">
          <div className="linkExpiryImage">
            <img src={LinkExpired} alt="expiry img" />
          </div>
          <div className="expiryContent">
            <h4>{pageContent.linkExpiredText}</h4>
            <h6>{pageContent.wrongMessgae}</h6>
            <div className="goHomeBtn mt-4" onClick={handleSucessClose}>
              {pageContent.linkBtnName}
            </div>
          </div>
        </div>
      )}

      <PopupAlert
        show={successModal}
        alertMessage={successMessage}
        handleSubmit={handleSucessClose}
      />
      <PopupAlertError
        status={statusCode}
        show={errorAlertShow}
        alertMessage={errorAlertMessage}
        errorAlertOnly={true}
        handleCancel={() => setErrorAlertShow(false)}
        handleSubmit={() => {
          setErrorAlertShow(false);
          document.getElementById("reSubmitbtns").click();
        }}
      />
    </div>

    // main div end
  );
};

export default ResetPasswordPage;
